"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var RelativeRoute_1 = __importDefault(require("../RelativeRoute"));
var pathUtils_1 = require("../../helpers/pathUtils");
var NavView = function (props) {
    var id = props.id, path = props.path, section = props.section, children = props.children, render = props.render, onRender = props.onRender, routeProps = __rest(props, ["id", "path", "section", "children", "render", "onRender"]);
    var prefix = id ? "/" + id : '';
    var resolvedPath = pathUtils_1.prefixPath(prefix, path);
    var content = (react_1.default.createElement(RelativeRoute_1.default, __assign({ exact: !id, path: resolvedPath, render: function (routerProps) {
            if (onRender)
                onRender(routerProps);
            if (render) {
                return render(routerProps);
            }
            return children;
        } }, routeProps)));
    return section ? react_1.default.createElement(RelativeRoute_1.default, { path: "/" + section, render: function () { return content; } }) : content;
};
exports.default = NavView;
